import * as Sentry from "@sentry/react";
import { env } from "env";
import { scrubDeep } from "utils/sentryScrub";

const parseSampleRate = (value: string | undefined, fallback: number) => {
  if (value === undefined || value === "") {
    return fallback;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < 0 || parsed > 1) {
    return fallback;
  }

  return parsed;
};

if (env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: env.REACT_APP_SENTRY_DSN,
    environment: env.REACT_APP_SENTRY_ENVIRONMENT || env.NODE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        beforeAddRecordingEvent: (event) => scrubDeep(event),
      }),
    ],
    // Team invite links carry a credential in the path; keep it out of every
    // event, transaction, breadcrumb and replay (see utils/sentryScrub).
    beforeSend: (event) => scrubDeep(event),
    beforeSendTransaction: (event) => scrubDeep(event),
    beforeBreadcrumb: (breadcrumb) => scrubDeep(breadcrumb),
    release: env.REACT_APP_SENTRY_RELEASE || undefined,
    replaysOnErrorSampleRate: parseSampleRate(
      env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
      1
    ),
    replaysSessionSampleRate: parseSampleRate(
      env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
      0
    ),
    sendDefaultPii: false,
    tracesSampleRate: parseSampleRate(
      env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
      0
    ),
  });
}
